module.exports = __webpack_public_path__ + "static/img/logo-home.674bad0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo-home.png
// module id = 1G6L
// module chunks = 18